/*!
    * @product/scmp-sdk 2.0.2
    * built by undefined
  */
import{j as t}from"./chunk-DFQCIK2Z.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-LJXGLQJU.js.map
